"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Permite realizar o gerenciamento centralizado do Axios, assim evitando a repetição de código
 */
class AxiosHelper {
  constructor(response) {
    _defineProperty(this, "status", void 0);

    this.status = response.status;
  }

  handleAxiosError(defaultErrorMessage) {
    const handledError = {
      errorMessage: defaultErrorMessage,
      statusCode: this.status
    };

    if (this.isResponseForbidden) {
      handledError.errorMessage = 'Você não tem permissão para acessar este conteúdo!';
    }

    if (this.isResponseUnauthorized) {
      handledError.errorMessage = 'Você não está logado para acessar este conteúdo!';
    }

    return handledError;
  }

  get isResponseUnauthorized() {
    return this.status === HttpResponses.Unauthorized;
  }

  get isResponseForbidden() {
    return this.status === HttpResponses.Forbidden;
  }

}

var _default = AxiosHelper;
exports.default = _default;
var HttpResponses;

(function (HttpResponses) {
  HttpResponses[HttpResponses["Unauthorized"] = 401] = "Unauthorized";
  HttpResponses[HttpResponses["Forbidden"] = 403] = "Forbidden";
  HttpResponses[HttpResponses["NotFound"] = 404] = "NotFound";
  HttpResponses[HttpResponses["InternalServerError"] = 500] = "InternalServerError";
})(HttpResponses || (HttpResponses = {}));